import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { JobLevelComponent } from './components/job-level.component';
import {  MatCheckboxModule } from '@angular/material/checkbox';



@NgModule({
    declarations: [
        JobLevelComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatCheckboxModule,
    ],
    exports: [
        JobLevelComponent
    ],
})
export class JobLevelModule {
}
